// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { fetchWalkscore } from '../../../../actions/properties'
import Card from '../../../../components/Card'

const WalkscoreLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  &:hover {
    text-decoration: none;
  }
`

const ScoreRow = styled.div`
  margin-bottom: 6px;
`

const ScoreLabel = styled.span`
  font-weight: bold;
  color: rgb(108, 150, 213);
  margin-right: 5px;
`

const Score = styled.span`
  font-weight: bold;
  margin-right: 5px;
  color: rgb(2, 69, 148);
`

type Props = {
  lat?: number,
  lng: number,
  address: string,
  walkscore: Object,
  fetchWalkscore: Function
}

class Walkscore extends Component {
  componentDidMount() {
    if (this.props.lat && this.props.lng) {
      this.props.fetchWalkscore(
        this.props.lat,
        this.props.lng,
        this.props.address
      )
    } else {
      this.calculateCoordinates(this.props.address)
    }
  }

  props: Props

  calculateCoordinates = (address: string) => {
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({ address }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        const lat = results[0].geometry.location.lat()
        const lng = results[0].geometry.location.lng()
        this.props.fetchWalkscore(lat, lng, address)
      }
    })
  }

  render() {
    const { walkscore } = this.props
    if (walkscore.status !== 1) return null

    return (
      <Card>
        <WalkscoreLink
          href={walkscore.ws_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={walkscore.logo_url}
            alt="Walkscore"
            style={{ marginRight: '6px' }}
          />
          <img src={walkscore.more_info_icon} alt="Info" />
        </WalkscoreLink>
        <ScoreRow>
          <ScoreLabel>Walk Score:</ScoreLabel>
          <Score>{walkscore.walkscore}</Score>
          <span>{walkscore.description}</span>
        </ScoreRow>
        {walkscore.bike && walkscore.bike.score && walkscore.bike.description && (
          <ScoreRow>
            <ScoreLabel>Bike Score:</ScoreLabel>
            <Score>{walkscore.bike.score}</Score>
            <span>{walkscore.bike.description}</span>
          </ScoreRow>
        )}
        {walkscore.transit &&
          walkscore.transit.score &&
          walkscore.transit.description && (
            <ScoreRow>
              <ScoreLabel>Transit Score:</ScoreLabel>
              <Score>{walkscore.transit.score}</Score>
              <span>{walkscore.transit.description}</span>
            </ScoreRow>
          )}
      </Card>
    )
  }
}

export default connect(
  (state) => ({
    walkscore: state.properties.walkscore
  }),
  {
    fetchWalkscore
  }
)(Walkscore)



// WEBPACK FOOTER //
// ./src/views/Property/components/Walkscore/index.js